import revenueChart from "@/assets/revenue-chart.png";

const GrowthSection = () => {
  return (
    <section className="w-full py-16 md:py-24 bg-background">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Image */}
          <div>
            <img
              src={revenueChart}
              alt="Revenue growth chart showing $124,592 total revenue with 24.5% increase"
              loading="lazy"
              decoding="async"
              className="w-full h-auto"
            />
          </div>

          {/* Right - Content */}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-normal text-foreground leading-tight">
              Grow like you've always wanted.
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
              Watch your revenue climb with AI-driven insights and automation. From traffic acquisition to checkout optimization, every touchpoint is engineered to maximize your bottom line.
            </p>
            <ul className="space-y-4 text-muted-foreground">
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-600 mt-2.5 flex-shrink-0" />
                <span>Real-time analytics that reveal hidden growth opportunities</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-600 mt-2.5 flex-shrink-0" />
                <span>Automated campaigns that scale with your success</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-600 mt-2.5 flex-shrink-0" />
                <span>Profit-first recommendations backed by data</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GrowthSection;
